export const EXECUTE_SEARCH_OPERATION =
  'operation::@bangle.io/search-notes:execute-search';
